import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoadingSpinner } from './ui';

/**
 * Страница само за влязъл потребител. Невлезлият отива на `/login` и носи `from` — след вход
 * родителят се връща тук (`utils/returnPath`), не на таблото (19.10: пряката връзка към
 * формата за подпис се губеше при вход).
 */
export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingSpinner />;

  return user ? <>{children}</> : <Navigate to="/login" state={{ from: location }} replace />;
}
